function loadSchedulerModal(schedule_id) {
    var ajaxurl = '<?php echo admin_url("admin-ajax.php"); ?>';
    jQuery('#schedule-modal-content').html("<div class='modal-header text-bg-secondary'><h1 class='modal-title h3' id='modalLabel'>Laden...</h1><button type='button' class='btn-close btn-close-white' data-bs-dismiss='modal' aria-label='Close'></button></div><div class='modal-body'><div class='loader'></div></div>");
    jQuery.ajax({
        url: ajax_object.ajaxurl,
        method: 'POST',
        data: {
            action: 'schedule_modal',
            post_id: schedule_id
        },
        success: function (response) {
            jQuery('#schedule-modal-content').html(response);
        },
        error: function () {
            console.log('Error getting post data');
        }
    });
}